module.exports = __webpack_public_path__ + "img/rabbit_logo.74c4ce6f.webp";